import React from 'react';
import { Grid, Typography, Box, Link } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
/* Modal */
import useStyles from '../../Main.style';

const MyGoals = ({ myProfessionalQuarterlyGoal }) => {
  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {/* <Box m={1} /> */}
        </Grid>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">My Goals</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If
                    condition={
                      myProfessionalQuarterlyGoal?.dataQ1?.goal1 &&
                      myProfessionalQuarterlyGoal?.dataQ1?.goal2 &&
                      myProfessionalQuarterlyGoal?.dataQ1?.goal3
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q1
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ1?.goal1 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ1?.goal2 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ1?.goal3 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                    </Box>
                  </If>
                  <If
                    condition={
                      !(
                        myProfessionalQuarterlyGoal?.dataQ1?.goal1 &&
                        myProfessionalQuarterlyGoal?.dataQ1?.goal2 &&
                        myProfessionalQuarterlyGoal?.dataQ1?.goal3
                      )
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q1
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 1st quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If
                    condition={
                      myProfessionalQuarterlyGoal?.dataQ2?.goal1 &&
                      myProfessionalQuarterlyGoal?.dataQ2?.goal2 &&
                      myProfessionalQuarterlyGoal?.dataQ2?.goal3
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q2
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ2?.goal1 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ2?.goal2 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ2?.goal3 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                    </Box>
                  </If>
                  <If
                    condition={
                      !(
                        myProfessionalQuarterlyGoal?.dataQ2?.goal1 &&
                        myProfessionalQuarterlyGoal?.dataQ2?.goal2 &&
                        myProfessionalQuarterlyGoal?.dataQ2?.goal3
                      )
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q2
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 2nd quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If
                    condition={
                      myProfessionalQuarterlyGoal?.dataQ3?.goal1 &&
                      myProfessionalQuarterlyGoal?.dataQ3?.goal2 &&
                      myProfessionalQuarterlyGoal?.dataQ3?.goal3
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q3
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ3?.goal1 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ3?.goal2 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ3?.goal3 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                    </Box>
                  </If>
                  <If
                    condition={
                      !(
                        myProfessionalQuarterlyGoal?.dataQ3?.goal1 &&
                        myProfessionalQuarterlyGoal?.dataQ3?.goal2 &&
                        myProfessionalQuarterlyGoal?.dataQ3?.goal3
                      )
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q3
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 3rd quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If
                    condition={
                      myProfessionalQuarterlyGoal?.dataQ4?.goal1 &&
                      myProfessionalQuarterlyGoal?.dataQ4?.goal2 &&
                      myProfessionalQuarterlyGoal?.dataQ4?.goal3
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q4
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ4?.goal1 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ4?.goal2 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                      {/* <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          <Typography variant="body2">
                            {myProfessionalQuarterlyGoal?.dataQ4?.goal3}
                          </Typography>
                        </Box>
                      </Box> */}
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {myProfessionalQuarterlyGoal?.dataQ4?.goal3 || 'Goal not defined yet'}
                        </Box>
                      </Box>
                    </Box>
                  </If>
                  <If
                    condition={
                      !(
                        myProfessionalQuarterlyGoal?.dataQ4?.goal1 &&
                        myProfessionalQuarterlyGoal?.dataQ4?.goal2 &&
                        myProfessionalQuarterlyGoal?.dataQ4?.goal3
                      )
                    }
                  >
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q4
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 4th quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Link color="textPrimary" href="/#/app/goals">
                      <Typography variant="caption">View all</Typography>
                    </Link>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
};

export default MyGoals;
